import {HttpClient} from '@angular/common/http';

import {Injectable} from '@angular/core';
import {
  Translation,
  TranslocoLoader,
} from '@jsverse/transloco';

@Injectable({providedIn: 'root'})
export class TranslocoHttpLoader implements TranslocoLoader {
  constructor(
    private readonly _http: HttpClient
  ) {
  }

  getTranslation(lang: string) {
    return this._http.get<Translation>(`/assets/i18n/${lang}.json`);
  }
}
